import { make } from 'vuex-pathify'
import Vue from 'vue'
import store from '../index'

const state = {
  loading: [false, false],
}

const mutations = make.mutations(state)

const createJob = async ({ state }, { reportCode, filter = {} }) => {
  const type = filter.type || 0
  Vue.set(state.loading, type, true)

  try {
    return await store.dispatch('reportJobStore/createJob', {
      module: 'financial',
      reportCode,
      format: type === 0 ? 'pdf' : 'csv',
      filters: filter,
    })
  } finally {
    Vue.set(state.loading, type, false)
  }
}

const actions = {
  getPayments: (ctx, filter = {}) => createJob(ctx, {
    reportCode: Number(filter.report) === 1 ? 'revenues' : 'expenses',
    filter,
  }),
  getFinancialResult: (ctx, filter = {}) => createJob(ctx, { reportCode: 'financialResult', filter }),
  getAccountMovement: (ctx, filter = {}) => createJob(ctx, { reportCode: 'accountMovement', filter }),
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
